import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./Dialog.module.scss";

/**
 * Dialog — controlled modal rendered into document.body.
 * 8px radius + ambient shadow. Closes on Esc and overlay click.
 */
export function Dialog({
  open,
  onClose,
  title = null,
  footer = null,
  width = 480,
  className,
  children,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && onClose) onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay} onMouseDown={onClose}>
      <div
        className={cn(styles.panel, className)}
        style={{ maxWidth: width }}
        role="dialog"
        aria-modal="true"
        onMouseDown={(e) => e.stopPropagation()}
      >
        {title ? <div className={styles.header}>{title}</div> : null}
        <div className={styles.body}>{children}</div>
        {footer ? <div className={styles.footer}>{footer}</div> : null}
      </div>
    </div>,
    document.body
  );
}

Dialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  footer: PropTypes.node,
  width: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Dialog;
